import { USER_REGISTRATION_ERRORS, USER_VERIFICATION_ERRORS } from 'constants/users';
import { FLEET_COUNT_FIELDS, VEHICLE_COUNT_COUNTRIES } from 'constants/selfRegistration';

export const getUserRegistrationError = serverErrors => {
  const defaultUserRegistrationError = 'InternalError';

  const domainErrorCode = serverErrors?.domainErrorCode;
  if (!domainErrorCode) return null;

  const errorMessage =
    Object.keys(USER_REGISTRATION_ERRORS).find(
      err => USER_REGISTRATION_ERRORS[err] === domainErrorCode,
    ) ?? defaultUserRegistrationError;

  return errorMessage;
};

export const getUserVerificationError = serverErrors => {
  const defaultUserVerificationError = 'InternalError';

  const domainErrorCode = serverErrors?.domainErrorCode;
  if (!domainErrorCode) return null;

  const errorMessage =
    Object.keys(USER_VERIFICATION_ERRORS).find(
      err => USER_VERIFICATION_ERRORS[err] === domainErrorCode,
    ) ?? defaultUserVerificationError;

  return errorMessage;
};

export const getQueryParameters = queryString => {
  const regex = /\b([vp])=([^&]*)/g;
  let match;
  let result = {};
  while ((match = regex.exec(queryString)) !== null) {
    result[match[1]] = match[2];
  }

  return result;
};

// Drivers is also the field shown before a country is picked.
export const getFleetCountField = country =>
  VEHICLE_COUNT_COUNTRIES.includes(country)
    ? FLEET_COUNT_FIELDS.vehicles
    : FLEET_COUNT_FIELDS.drivers;
